import { render } from "./IconButton.vue?vue&type=template&id=3ea840a4"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/IconButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ea840a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ea840a4', __exports__)) {
    api.reload('3ea840a4', __exports__)
  }
  
  module.hot.accept("./IconButton.vue?vue&type=template&id=3ea840a4", () => {
    api.rerender('3ea840a4', render)
  })

}


export default __exports__